import React, { Component } from 'react';
import { connect } from 'react-redux';
import './DepositContainer.css';
import PropTypes from 'prop-types';
import Input from 'components/shared/input/Input';
import Number from 'components/shared/text/Number';
import {
  getDepositSelected,
  getDepositCost,
} from 'selectors/admin/work-orders/details/proposal';
import CheckBox from 'components/shared/checkbox/CheckBox';
import {
  depositSelectedChange,
  depositCostChange,
} from 'actions/admin/work-orders/details/proposal';

class DepositContainer extends Component {
  static propTypes = {
    readOnly: PropTypes.bool,
  };

  static defaultProps = {
    readOnly: false,
  };

  render() {
    return (
      (!this.props.readOnly || this.props.depositCost !== null) && (
        <div className="deposit-container">
          <div className="h3">Deposit</div>

          <div className="deposit-viewer">
            <div className="line">
              <CheckBox
                checked={this.props.depositSelected}
                readOnly={this.props.readOnly}
                onChange={this.handleDepositSelectedChange}
              />
              <div className="deposit-label">
                A deposit of
                {this.props.readOnly ? (
                  <Number
                    className="deposit-cost-read-only"
                    value={this.props.depositCost}
                    format="$0,0"
                  />
                ) : (
                  <Input
                    type="number"
                    value={this.props.depositCost || ''}
                    readOnly={!this.props.depositSelected}
                    onChange={this.handleDepositCostChange}
                  />
                )}
                is required prior to the start of work
              </div>
            </div>
          </div>
        </div>
      )
    );
  }

  handleDepositSelectedChange = () => {
    if (this.props.depositSelected) {
      this.props.dispatch(depositCostChange(null));
    }

    this.props.dispatch(depositSelectedChange(!this.props.depositSelected));
  };

  handleDepositCostChange = (value) => {
    this.props.dispatch(depositCostChange(value === '' ? null : value));
  };
}

export default connect((state) => {
  return {
    depositSelected: getDepositSelected(state),
    depositCost: getDepositCost(state),
  };
})(DepositContainer);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/deposit/DepositContainer.js